import { CSSProperties } from 'react';
import styled, { css } from 'styled-components';

import CustomIcon from '../Icons/CustomIcon';

import Theme from '../../../styles/Theme/Theme';

type TCircle = {
    size?: number;
    customPosition?: 'top-left' | 'top-right' | 'bottom-left' | 'bottom-right';
    customColor?: keyof typeof Theme.color;
};

const Circle = styled.div<CSSProperties & TCircle>`
    position: absolute;

    ${({ customPosition, size }) => {
        switch (customPosition) {
            case 'top-right':
                return css`
                    top: 0;
                    right: 0;
                `;
            case 'top-left':
                return css`
                    top: 0;
                    left: 0;
                    transform: rotate(-90deg);
                `;
            case 'bottom-right':
                return css`
                    bottom: 0;
                    right: 0;
                    transform: rotate(90deg);
                `;
            case 'bottom-left':
                return css`
                    bottom: 0;
                    left: 0;
                    transform: rotate(180deg);
                `;
            default:
                return css`
                    top: 0;
                    right: 0;
                `;
        }
    }}

    z-index: ${({ zIndex }) => (zIndex ? zIndex : -1)};
`;

const NovaCircle = ({ size, customColor, customPosition, zIndex }: TCircle & CSSProperties) => {
    return (
        <Circle size={size} customPosition={customPosition} zIndex={zIndex}>
            <CustomIcon icon="NovaRing" customColor={customColor ? customColor : 'white'} width={size} height={size} />
        </Circle>
    );
};

export default NovaCircle;
